const toFile = (blob: Blob, fileName: string) => new File([blob], fileName, { type: blob.type });

/** Image clipboard writes need ClipboardItem, which older Firefox lacks. */
export const canCopyImage = () =>
  typeof ClipboardItem !== "undefined" && typeof navigator.clipboard?.write === "function";

export const copyImage = (blob: Blob) =>
  navigator.clipboard.write([new ClipboardItem({ [blob.type]: blob })]);

export const downloadImage = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

/** True where the OS share sheet accepts image files. */
export const canNativeShare = (blob: Blob, fileName: string) => {
  if (typeof navigator.canShare !== "function") return false;
  try {
    return navigator.canShare({ files: [toFile(blob, fileName)] });
  } catch {
    return false;
  }
};

/** Resolves to false when the user closed the share sheet without sharing. */
export const nativeShare = async (blob: Blob, fileName: string): Promise<boolean> => {
  try {
    await navigator.share({ files: [toFile(blob, fileName)] });
    return true;
  } catch (error) {
    if (error instanceof DOMException && error.name === "AbortError") return false;
    throw error;
  }
};
